import { IEnvironment } from '../app/core/interfaces';

/**
 * Runtime environment configuration.
 *
 * The object below provides STATIC defaults that Angular's AOT compiler can
 * analyse (required for NgModule metadata that references `environment`).
 *
 * Immediately after the object is created, `Object.assign` merges in any
 * values from `window['__env']`, which is set by the <script src="env.js">
 * tag in index.html — **before** any Angular bundle code executes.
 *
 * In Docker the entrypoint generates env.js from environment variables.
 * During local `ng serve` the checked-in src/env.js provides dev defaults.
 */

export const environment: IEnvironment = {
  version: '1.2.5',
  production: true,
  il2: false,
  il4: false,
  classic: false,
  apiUrl: 'http://localhost:3000',
  clientUrl: 'http://localhost:4200',
  firebaseConfig: {
    apiKey: 'AIzaSyDodeP_q-rkLSRtPN7lIHrDb5m2Rr9l0B0',
    authDomain: 'proflyt.firebaseapp.com',
    databaseURL: 'https://proflyt.firebaseio.com',
    projectId: 'proflyt',
    storageBucket: 'proflyt.appspot.com',
    messagingSenderId: '853525073122',
    appId: '1:853525073122:web:eebd9909a52b1591d922bb',
    measurementId: 'G-286E18VW9Z',
  },
  appIdentifier: 'com.ProFlyt.ProFlyt',
  iosAppId: '1548088693',
  apiBaseUrl: 'http://localhost:3000',
  itsScrappingUrl: 'http://localhost:8001',
  itsScrappingToken: 'BwdeTOymZbXPxPKFoxMieZSye5nDWsRo',
  authProvider: 'rest',
  keycloakConfig: {
    realm: 'test',
    clientId: 'proflyt-web-app-client',
    url: 'http://localhost:8081',
  },
  metreaDemo: {
    squadronName: 'Metrea',
  },
};

// ---------------------------------------------------------------------------
// Merge runtime config from window.__env (set by env.js before Angular loads)
// Object.assign mutates the const object in-place — the reference is stable so
// every module that imported `environment` sees the updated values.
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined' && (window as any)['__env']) {
  const rt = (window as any)['__env'];
  Object.assign(environment, rt);

  // Deep-merge nested objects so partial overrides don't wipe sibling keys
  if (rt.firebaseConfig) {
    Object.assign(environment.firebaseConfig, rt.firebaseConfig);
  }
  if (rt.keycloakConfig) {
    Object.assign(environment.keycloakConfig, rt.keycloakConfig);
  }
  if (rt.metreaDemo) {
    Object.assign(environment.metreaDemo, rt.metreaDemo);
  }
}
